(function () {
  'use strict';

  function setCookie(name, value, days) {
    var expires = '';
    if (days && days > 0) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }

  function initPopup(root) {
    if (!root || root.getAttribute('data-amc-bound') === '1') return;
    root.setAttribute('data-amc-bound', '1');

    var enabled = root.getAttribute('data-enabled') === 'true';
    var testMode = root.getAttribute('data-test-mode') === 'true';
    var days = parseInt(root.getAttribute('data-delay-days') || '2', 10);
    var cookieName = 'amc-halloween-popup-' + (root.getAttribute('data-section-id') || 'default');
    var teaser =
      document.querySelector('[data-amc-halloween-teaser]') ||
      (root.parentElement && root.parentElement.querySelector('[data-amc-halloween-teaser]'));
    var video = root.querySelector('[data-amc-halloween-video]');
    var reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!enabled && !testMode) return;
    if (window.location.pathname === '/challenge' || window.location.pathname === '/password') return;

    var scrollLockY = 0;
    var scrollLocked = false;

    function lockScroll() {
      if (scrollLocked) return;
      scrollLocked = true;
      scrollLockY = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = -scrollLockY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
    }

    function unlockScroll() {
      if (!scrollLocked) return;
      scrollLocked = false;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      window.scrollTo(0, scrollLockY);
    }

    function showTeaser(on) {
      if (!teaser) return;
      if (on) {
        teaser.hidden = false;
        teaser.classList.add('is-visible');
        document.documentElement.classList.add('amc-halloween-teaser-on');
      } else {
        teaser.hidden = true;
        teaser.classList.remove('is-visible');
        document.documentElement.classList.remove('amc-halloween-teaser-on');
      }
      window.dispatchEvent(new Event('resize'));
    }

    function playVideo() {
      if (!video) return;
      var src = video.getAttribute('data-src');
      if (src && video.getAttribute('src') !== src) {
        video.setAttribute('src', src);
        video.load();
      }
      video.muted = true;
      video.defaultMuted = true;
      video.loop = !reduceMotion;
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }

    function pauseVideo() {
      if (!video) return;
      try {
        video.pause();
        video.currentTime = 0;
      } catch (e) {}
    }

    function open() {
      showTeaser(false);
      root.hidden = false;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      lockScroll();
      playVideo();
    }

    function close(persist) {
      root.classList.remove('is-open');
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
      unlockScroll();
      pauseVideo();
      if (persist !== false && days > 0) {
        setCookie(cookieName, '1', days);
      }
      if (persist !== false) showTeaser(true);
    }

    root.querySelectorAll('[data-amc-halloween-popup-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        close(true);
      });
    });

    var cta = root.querySelector('[data-amc-halloween-popup-cta]');
    if (cta) {
      cta.addEventListener('click', function () {
        close(true);
      });
    }

    if (teaser && teaser.getAttribute('data-amc-teaser-bound') !== '1') {
      teaser.setAttribute('data-amc-teaser-bound', '1');
      teaser.addEventListener('click', function () {
        open();
      });
    }

    function onEsc(e) {
      if (e.key !== 'Escape' || !root.classList.contains('is-open')) return;
      close(true);
    }
    document.addEventListener('keydown', onEsc);

    showTeaser(true);

    document.addEventListener(
      'shopify:section:unload',
      function () {
        document.removeEventListener('keydown', onEsc);
        close(false);
        showTeaser(false);
      },
      { once: true }
    );
  }

  function boot() {
    document.querySelectorAll('[data-amc-halloween-popup]').forEach(initPopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    var node =
      e.target.querySelector('[data-amc-halloween-popup]') ||
      (e.target.matches && e.target.matches('[data-amc-halloween-popup]') ? e.target : null);
    if (node) initPopup(node);
  });
})();
